const ImageLoader = ({ className = '' }: { className?: string }) => (
  <div
    className={`relative flex size-16 items-center justify-center ${className}`}
    role="status"
    aria-label="Loading image"
  >
    {/* Outer animated ring */}
    <div className="absolute inset-0 animate-ping rounded-full bg-primary/20" />

    {/* Main loader circle */}
    <div className="relative flex size-12 items-center justify-center rounded-full bg-white shadow-lg">
      <div className="absolute inset-0 rounded-full border-4 border-primary/20" />

      <div className="absolute inset-0 animate-spin rounded-full border-4 border-transparent border-t-primary border-r-primary" />

      {/* Image icon */}
      <svg
        className="relative size-6 text-primary"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      >
        <rect x="3" y="3" width="18" height="18" rx="3" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="M3 16l5-5 4 4 2.5-2.5L21 17" />
      </svg>
    </div>
  </div>
);

export default ImageLoader;
